import { useState } from 'react';
import type { ResultEntry } from '@filmsloth/shared';
import { useMovieTitle, useT } from '../i18n/index.js';
import { rankingText } from '../lib/rankingText.js';
import { share } from '../lib/share.js';

/**
 * Sends the top of the ranking to the group chat — for the evening that ends
 * without a pick, and for the one where people want to remember the runners-up.
 *
 * Says what actually happened, like `ShareButton`: the system sheet and the
 * clipboard are different outcomes.
 */
export function ShareRankingButton({ results }: { results: ResultEntry[] }) {
  const t = useT();
  const movieTitle = useMovieTitle();
  const [outcome, setOutcome] = useState<'copied' | 'failed' | null>(null);

  const text = rankingText(results, t, movieTitle);
  if (!text) return null;

  const label =
    outcome === 'copied'
      ? t('share.copied')
      : outcome === 'failed'
        ? t('share.failed')
        : t('ranking.share');

  return (
    <button
      type="button"
      className="btn btn--block"
      onClick={() => {
        void share({ title: t('ranking.shareHeader'), text }).then((result) => {
          if (result === 'copied') setOutcome('copied');
          else if (result === 'failed') setOutcome('failed');
          else setOutcome(null);
        });
      }}
    >
      {label}
    </button>
  );
}
